import { ALLOWED_LOCALES, DEFAULT_LOCALE } from './locale';

export const POPULATION_ALLOWED_MESSAGE =
  'Allowed (case-insensitive): adult/adults, child/children. Use comma to separate values.';

const POPULATION_CANONICAL = {
  child: 'CHILDREN',
  children: 'CHILDREN',
  adult: 'ADULTS',
  adults: 'ADULTS',
};

export const ensureLettersOnly = (value, fieldName) => {
  const raw = String(value ?? '').trim();
  if (!raw) return raw;
  if (!/^[a-zA-Z]+$/.test(raw)) {
    throw new Error(`Invalid ${fieldName} "${raw}". Use letters only (no spaces/symbols).`);
  }
  return raw;
};

export const parseLocale = (value) => {
  const raw = ensureLettersOnly(value, 'locale');
  if (!raw) return DEFAULT_LOCALE;
  const upper = raw.toUpperCase();
  if (ALLOWED_LOCALES.has(upper)) return upper;
  throw new Error(`Invalid locale "${raw}". Allowed: ${Array.from(ALLOWED_LOCALES).join(', ')} (case-insensitive).`);
};

export const parsePopulation = (value) => {
  if (value == null || String(value).trim() === '') return [];

  const rawAll = String(value).trim();
  if (rawAll.includes(';')) {
    throw new Error('Invalid population separator. Use comma (,) only.');
  }

  const parts = rawAll
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  const mapped = parts.map((p) => {
    const raw = ensureLettersOnly(p, 'population');
    const token = raw.toLowerCase();
    const canonical = POPULATION_CANONICAL[token];
    if (canonical) return canonical;
    throw new Error(`Invalid population "${raw}". ${POPULATION_ALLOWED_MESSAGE}`);
  });

  return mapped.filter((p, idx) => mapped.indexOf(p) === idx);
};
